<template>
  <div>
    <b-card>
      <h5 class="p-2">R6 — Items below minimum / critical / empty</h5>
      <b-table :items="filtered" :fields="fields" bordered responsive show-empty>
        <template #cell(stock_status)="data">
          <b-badge :variant="variant(data.item.stock_status)">{{ data.item.stock_status }}</b-badge>
        </template>
      </b-table>
    </b-card>
    <ToastNotification ref="toast" />
  </div>
</template>

<script>
import { BCard, BTable, BBadge } from 'bootstrap-vue'
import ToastNotification from '@/components/ToastNotification'
import invStockApi from '@/core/services/api/weightloss-inventory/stock'
import { resolveNumericFacilityId } from '@/core/services/api/weightloss-inventory/facility'

export default {
  name: 'ReportLowStock',
  components: { BCard, BTable, BBadge, ToastNotification },
  data() {
    return {
      items: [],
      fields: [{ key: 'name' }, { key: 'stock' }, { key: 'reorder_point' }, { key: 'stock_status', label: 'Status' }],
    }
  },
  computed: {
    filtered() {
      return this.items.filter(i => ['low', 'critical', 'empty'].includes(i.stock_status))
    },
  },
  mounted() {
    const params = {}
    const fid = resolveNumericFacilityId()
    if (fid) params.facility_id = fid
    invStockApi.list(params).then(r => { this.items = r }).catch(e => this.$refs.toast.danger(e.message))
  },
  methods: {
    variant(s) {
      return { low: 'warning', critical: 'danger', empty: 'secondary' }[s] || 'info'
    },
  },
}
</script>
